module.exports = __webpack_public_path__ + "static/img/fund3.1610b4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/fundClassify/fund3.png
// module id = 4omR
// module chunks = 0